export class Category{
    categoryId!: string
    externalId!: string
    deeplinkDescription!: string
    description!: string
    label!: string
    storeId!: string
    imageUrl!: string
    colorHex!: string
    ordinalNumber!: number
    root!: boolean
    parentCategoryId!: string
    deleted!: boolean
    categories!: Category[]
    subCategories?: Category[]
    productCount?: number
    deeplink?: string
}
